import React from 'react';
import { RouteObject } from 'react-router-dom';
import { appRoutes } from '../../path';
import ProtectedRoute from '../../components/ProtectedRoute';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import MeasureDictionary from './Measures';
import EventDictionary from './Events/EventDictionary';
import VirtualEventDictionary from './VirtualEvents/VirtualEventDictionary';
import FieldDictionary from './Fields';
import FilterDictionary from './Filters/FilterDictionary';
import BinningDictionary from './Binnings/BinningDictionary';
import RedirectRoute from '../RedirectRoute';
import SidebarLayout from '../../Layout/SidebarLayout';
import DictionaryNav from './DictionaryNav';

const dictionaryRoutes: RouteObject[] = [
  {
    element: (
      <SidebarLayout>
        <DictionaryNav />
      </SidebarLayout>
    ),
    children: [
      {
        path: '/dictionary',
        element: (
          <RedirectRoute from="/dictionary" to={appRoutes.dictionary.event} />
        ),
      },
      {
        path: appRoutes.dictionary.measure,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.MeasureRead]}
            pageNameWithSubPermissions={'dictionary'}
          >
            <MeasureDictionary />
          </ProtectedRoute>
        ),
      },
      {
        path: appRoutes.dictionary.event,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.EventRead]}
            pageNameWithSubPermissions={'dictionary'}
          >
            <EventDictionary />
          </ProtectedRoute>
        ),
      },
      {
        path: appRoutes.dictionary.virtualEvent,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.VirtualEventRead]}
            pageNameWithSubPermissions={'dictionary'}
          >
            <VirtualEventDictionary />
          </ProtectedRoute>
        ),
      },
      {
        path: appRoutes.dictionary.field,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.FieldRead]}
            pageNameWithSubPermissions={'dictionary'}
          >
            <FieldDictionary />
          </ProtectedRoute>
        ),
      },
      {
        path: appRoutes.dictionary.filter,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.FilterRead]}
            pageNameWithSubPermissions={'dictionary'}
          >
            <FilterDictionary />
          </ProtectedRoute>
        ),
      },
      {
        path: appRoutes.dictionary.buckets,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.BucketDefRead]}
            pageNameWithSubPermissions={'dictionary'}
          >
            <BinningDictionary />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default dictionaryRoutes;
